export default __webpack_public_path__ + "static/media/footer-logo.c05d60d6.svg";